import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  input,
  model,
  OnInit,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'lib-accordion-card',
  templateUrl: './accordion-card.component.html',
  styleUrls: ['./accordion-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class AccordionCardComponent implements OnInit {
  id = input<string>();
  title = input<string>();
  subtitle = input<string>();
  titleTemplate = contentChild<TemplateRef<unknown>>('titleTemplate');

  /* Behavior properties */
  isOpen = model(false);
  isAlwaysOpen = input<boolean>(false);
  isCollapsable = model<boolean>(true);
  hideBorder = input<boolean>(false);
  breakWordForTitle = input<boolean>(false);
  isReadonly = input<boolean>(false);

  /* Accordion card storybook */
  isStorybookPreview = input<boolean>(false);

  ngOnInit(): void {
    this.isOpen.set(this.isAlwaysOpen() ? true : this.isOpen());
  }

  toggleCollapse(): void {
    if (this.isAlwaysOpen()) {
      return;
    }
    if (this.isCollapsable()) {
      this.isOpen.set(!this.isOpen());
    }
  }

  onContainerClick(event: MouseEvent): void {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    // Ignore clicks originating from the content area so nested controls do not toggle the accordion.
    if (target.closest('.accordion-card-content')) {
      return;
    }

    this.toggleCollapse();
  }

  onContainerKeydown(event: KeyboardEvent): void {
    // Ignore bubbled keydown events from nested focusable elements.
    if (event.target !== event.currentTarget) {
      return;
    }

    event.preventDefault();
    this.toggleCollapse();
  }
}
